import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
import VuexPersistence from "vuex-persist";

import questionsStore from "./modules/questions.store";
import taxInfoStore from "./modules/taxInfo.store";
import vatCompareStore from "./modules/vatCompare.store";
import rateUsStore from "./modules/rateUs.store";
import emailStore from "./modules/email.store";
import appStore from "./modules/app.store";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app: appStore,
    questions: questionsStore,
    taxInfo: taxInfoStore,
    vatCompare: vatCompareStore,
    rateUs: rateUsStore,
    email: emailStore,
  },
  plugins: [new VuexPersistence().plugin, createLogger()],
});
